module.exports = __webpack_public_path__ + "static/media/fontello.a2c982a0.ttf";